// removed by extract-text-webpack-plugin
module.exports = {"text800":"_3pNhebx3n9CY0q7BXM6dVV","text700":"_1PYD-LRqA2lEZeOT7Gv18S","text600":"JOzHg57Q9xfmjMmYUp5cx","text500":"oCpfLy4U2AxlV_xx-OQPQ","text400":"_1tMpvaep6a_vyLcYtW79kE","text300":"_3Cp_QdRQnJ-HCTIqByge0o","text200":"sPAENOvABN4G9ZPoXxAD4","textParagraph":"_12eaokvPAZhCevc9g7zEhW","crimp":"_1dPqQti1i51iZssKLhF3na","trim":"I8HzVcpsFq6_avc4OAnVc","flexCenter":"_7hxppo47Cu6nJXHhK8nYr","toggleAside":"_2Ve1otHysp1563FQyXSPWG","hideTextOverflow":"_7X38tqYTyWY8aVCBZERcR","marginPageMainContent":"XwTR4UGdyEI0CIB3PZl2m"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/ButtonToggleAside.scss
// module id = 800
// module chunks = 0